
import 'phoenix_html';

import topbar from 'topbar'
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import Alpine from 'alpinejs';
import {Socket} from 'phoenix';
import {LiveSocket} from 'phoenix_live_view';
import tippy, {hideAll} from 'tippy.js';

import {init as initDocumentEditor} from './document_editor';
import Hooks from './hooks';
import {updateDateTags, updateTimeTags} from './hooks/dateTime';

Alpine.plugin(persist)

Alpine.plugin(collapse)

const Uploaders = {}

Uploaders.S3 = (entries, onViewError) => {
  entries.forEach((entry) => {
    const formData = new FormData()
    const {url, fields} = entry.meta

    Object.entries(fields).forEach(([key, val]) => formData.append(key, val))
    formData.append('file', entry.file)
    const xhr = new XMLHttpRequest()

    onViewError(() => xhr.abort())
    xhr.onload = () => xhr.status === 204 ? entry.progress(100) : entry.error()
    xhr.onerror = () => entry.error()
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100)

        if (percent < 100) {
          entry.progress(percent)
        }
      }
    })

    xhr.open('POST', url, true)
    xhr.send(formData)
  })
}

document.addEventListener('alpine:init', () => {
  Alpine.magic('tooltip', (element) => (message) => {
    const instance = tippy(element, {content: message, placement: 'right-start', theme: 'tertiaryTooltip', trigger: 'manual'})

    if (!Alpine.store('mobileNav').openMobileMenu) {
      instance.show()
    } else {
      instance.hide()
    }
  })
  Alpine.magic('clearTooltips', () => {
    return hideAll({duration: 0});
  })
  Alpine.store('mobileNav', {
    openMobileMenu: false,
    open() {
      this.openMobileMenu = true
    },
    close() {
      this.openMobileMenu = false
    },
  })
})

// eslint-disable-next-line complexity
function checkVersion() {
  const agent = window.navigator.userAgent
  const start = agent.indexOf('OS')

  if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
    return window.Number(agent.substr(start + 3, 3).replace('_', '.'))
  }
  return 0
}

function setupLiveView() {
  const csrfMeta = document.querySelector("meta[name='csrf-token']")

  topbar.config({barColors: {0: '#B5E48C', 1.0: '#19628B'}, shadowColor: 'rgba(0, 0, 0, .3)', barThickness: 5})
  window.addEventListener('phx:page-loading-start', (_info) => topbar.show())
  window.addEventListener('phx:page-loading-stop', (_info) => topbar.hide())

  if (csrfMeta) {
    const csrfToken = csrfMeta.getAttribute('content')
    const liveSocket = new LiveSocket('/live', Socket, {
      hooks: Hooks,
      uploaders: Uploaders,
      // eslint-disable-next-line camelcase
      params: {
        _csrf_token: csrfToken,
        iosVersion: checkVersion(),
        timezone: (new Intl.DateTimeFormat().resolvedOptions()).timeZone,
      },
      dom: {
        onBeforeElUpdated(fromContent, toContent) {
          if (fromContent._x_dataStack) {
            Alpine.clone(fromContent, toContent)
          }
        },
      },
    })

    liveSocket.connect()
  }
}


function init() {
  updateTimeTags()
  updateDateTags()
  setupLiveView()
  initDocumentEditor()
  window.Alpine = Alpine
  Alpine.start()
}

document.addEventListener('DOMContentLoaded', () => {
  init()
})

export default {
  init,
}
